<template>
  <section
    id="itb-contact-form"
    :class="[
      this.$route.name == 'home' ? 'bg-white' : 'itb-horizontal-border ',
    ]"
  >
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6" id="itb-form-fields">
          <div class="itb-contextual-wrapper">
            <h2>
              {{ $t("general.do_you_want_playground_draft") }}
            </h2>
            <h3 style="padding-top: 8px">
              {{ $t("general.contact_us_we_solve_it") }}
            </h3>

            <form id="form" @submit.prevent="save">
              <div class="row mt-5 mb-4 mr-0">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div v-if="message">
                        <div
                          :class="'alert alert-' + message.type"
                          role="alert"
                          v-if="message"
                        >
                          {{ message.text }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-lg-12 col-xl-6">
                  <label for="itb-contact-form-region">{{
                    $t("general.where_are_you")
                  }}</label>
                  <select
                    class="form-control itb-mb itb-placeholder-select"
                    id="itb-contact-form-region"
                    v-model.trim="region"
                    ref="region"
                  >
                    <option value selected>
                      {{ $t("general.choose_your_region") }}
                    </option>
                    <option
                      v-for="location in this.appParams.locations"
                      :value="location.id"
                    >
                      {{ location.name }}
                    </option>
                  </select>
                  <label
                    for="itb-contact-form-phone"
                    :class="{
                      'itb-label-error': $v.contact.$error,
                    }"
                    >{{ $t("general.how_to_contact_you") }}</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="itb-contact-form-phone"
                    :placeholder="$t('general.leave_us_phone_or_email')"
                    v-model.trim="contact"
                    @input="$v.contact.$touch()"
                    :class="{
                      'itb-field-error': $v.contact.$error,
                    }"
                    ref="contact"
                  />
                  <div v-if="$v.contact.$dirty">
                    <p
                      class="itb-error-message"
                      v-if="!$v.contact.required"
                      aria-live="assertive"
                    >
                      {{ $t("general.contact_must_not_be_empty") }}
                    </p>
                  </div>
                  <div class="mb-0 mt-4">
                    <div
                      class="itb-contact-attachment d-flex align-items-center mb-0"
                    >
                      <p
                        class="mb-0"
                        :class="{
                          'itb-label-error': exceedSizeLimit,
                        }"
                      >
                        {{ $t("general.want_attach_file") }}
                      </p>
                      <button
                        type="button"
                        class="ml-2 mb-0"
                        :class="{
                          'itb-attach-disabled': submitStatus,
                          'itb-attach-enabled': !submitStatus,
                        }"
                        :disabled="submitStatus"
                        @click="$refs.attachFileInput.click()"
                      >
                        <span class="mdi mdi-paperclip"></span>
                        <span>
                          {{ $t("general.choose_file") }}
                        </span>
                      </button>

                      <input
                        type="file"
                        ref="attachFileInput"
                        style="display: none"
                        @change="attachFile($event)"
                      />
                    </div>
                    <div v-if="isFileLoaded" class="d-flex align-items-center">
                      <p class="mb-0">
                        {{ displayedFileName }}
                      </p>
                      <img
                        src="/images/cancel.png"
                        alt="delete"
                        class="itb-delete-button ml-2 mb-0"
                        v-if="!submitStatus"
                        @click="discardAttachment"
                      />
                    </div>
                    <div
                      v-if="exceedSizeLimit"
                      class="d-flex align-items-center"
                    >
                      <p
                        class="itb-error-message mb-0 mt-0"
                        aria-live="assertive"
                      >
                        {{ $t("general.file_should_be_smaller") }}
                      </p>
                      <img
                        src="/images/cancel.png"
                        alt="delete"
                        class="itb-delete-button ml-2 mb-0"
                        style="width: 27px"
                        v-if="!submitStatus"
                        @click="discardAttachment"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="col-6 d-none d-sm-flex d-lg-none d-xl-flex flex-column justify-content-center"
                  id="itb-form-info"
                >
                  <p>
                    {{ $t("general.we_will_contact_you_after_form_submit") }}
                    <strong>{{ $t("general.region_specialist") }}</strong>
                    {{ $t("general.who_will_checkout_all_your_inquiries") }}
                  </p>
                  <p class="mb-2">
                    <strong>{{ $t("general.proposal") }}</strong>
                    {{ $t("general.playground_you_have") }}
                    <strong>{{ $t("general.free") }}</strong
                    >.
                  </p>
                  <p class="mb-0">
                    {{ $t("general.or_just_call_us") }}
                    <br />
                    <a :href="'tel:' + stripedPhone" itemprop="telephone">{{
                      appParams.general_phone
                    }}</a>
                  </p>
                </div>
              </div>
              <label
                for="itb-contact-form-message"
                :class="{
                  'itb-label-error': $v.content.$error,
                }"
                >{{ $t("general.what_should_we_know") }}</label
              >
              <textarea
                class="form-control itb-mb"
                id="itb-contact-form-message"
                rows="5"
                :placeholder="$t('general.describe_your_vision')"
                v-model.trim="content"
                @input="$v.content.$touch()"
                :class="{
                  'itb-field-error': $v.content.$error,
                }"
                ref="content"
              ></textarea>
              <div v-if="$v.content.$dirty">
                <p
                  class="itb-error-message"
                  v-if="!$v.content.required"
                  aria-live="assertive"
                >
                  {{ $t("general.description_must_not_be_empty") }}
                </p>
              </div>
              <div class="mb-3 d-sm-none d-lg-block d-xl-none">
                <p class="mb-2">
                  {{ $t("general.we_will_contact_you_after_form_submit") }}t
                  <strong>{{ $t("general.region_specialist") }}</strong>
                  ,
                  {{ $t("general.who_will_checkout_all_your_inquiries") }}
                </p>
                <p class="mb-2">
                  <strong>{{ $t("general.proposal") }}</strong>
                  {{ $t("general.playground_you_have") }}
                  <strong>{{ $t("general.free") }}</strong
                  >.
                </p>
                <p class="mb-0">
                  {{ $t("general.or_just_call_us") }}
                  <br />
                  <a :href="'tel:' + stripedPhone" itemprop="telephone">{{
                    appParams.general_phone
                  }}</a>
                </p>
              </div>
              <button
                type="submit"
                class="btn btn-primary itb-btn-icon"
                :disabled="submitStatus"
              >
                {{ $t("general.send_a_message") }}
                <img
                  src="/images/icons/4soft_icon_paperplane.svg"
                  :alt="$t('general.submit_button')"
                  class="itb-icon itb-paperplane"
                />
              </button>
            </form>
          </div>
        </div>
        <div
          class="col-6 d-none d-lg-flex justify-content-center align-items-center"
          id="itb-form-image"
          v-lazy-container="{ selector: '.itb-lazy' }"
        >
          <img
            class="itb-lazy-loading-bg itb-lazy"
            data-src="/images/articles/contact-form-team.webp"
            :alt="$t('general.team_4soft')"
            style="max-width: 100%"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      valid: true,
      message: null,
      submitStatus: false,
      region: "",
      contact: "",
      content: "",
      file: null,
      exceedSizeLimit: false,
      isFileLoaded: false,
      displayedFileName: "",
    };
  },

  computed: {
    ...mapGetters({ appParams: "getAppParams" }),

    stripedPhone() {
      return this.appParams.general_phone
        ? String(this.appParams.general_phone).replace(/\s/g, "")
        : "";
    },
  },

  validations: {
    contact: {
      required,
    },
    content: {
      required,
    },
  },

  methods: {
    async save() {
      var toData = new FormData();
      var url =
        window.location.origin +
        (this.$route.path != "/" ? this.$route.path : "");
      toData.append("region", this.region);
      toData.append("contact", this.contact);
      toData.append("content", this.content);
      toData.append("url", url);
      toData.append("fileLinkPrefix", window.location.origin);
      if (this.file instanceof File) {
        if (!this.exceedSizeLimit) {
          toData.append("file", this.file);
        }
      } else {
        toData.append("file", "none");
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = false;
        for (let key in Object.keys(this.$v)) {
          const input = Object.keys(this.$v)[key];
          if (input.includes("$")) return false;
          if (this.$v[input].$error) {
            this.$refs[input].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            break;
          }
        }
      } else {
        if (!this.exceedSizeLimit) {
          this.submitStatus = "true";

          await axios
            .post("/sendMessage", toData)
            .then((response) => {
              this.message = {
                text: this.$t("general.contact_form_sent_succesfully"),
                type: "success",
              };

              this.sentGAFormEvent();

              this.$v.$reset();
              this.region = "";
              this.contact = "";
              this.content = "";
              this.isFileLoaded = false;
              this.exceedSizeLimit = false;
              this.file = null;
              setTimeout(() => {
                this.message = null;
              }, 3000);
              if (typeof ga === "function") {
                ga("send", "event", {
                  eventCategory: "contactForm",
                  eventAction: "click",
                  eventLabel: "odeslat",
                  eventValue: 2,
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.isFileLoaded = false;
              this.exceedSizeLimit = false;
              this.file = null;
              this.message = {
                text: this.$t("general.contact_form_error"),
                type: "danger",
              };

              setTimeout(() => {
                this.message = null;
              }, 3000);
            });

          setTimeout(() => {
            this.submitStatus = false;
          }, 500);
        }
      }
    },

    attachFile(event) {
      this.file = event.target.files[0];
      this.displayedFileName = this.file.name.trim();
      // size limit  10000000 bytes
      if (this.file.size > 10000000) {
        this.exceedSizeLimit = true;
        this.isFileLoaded = false;
      } else {
        if (this.displayedFileName.length > 40) {
          this.displayedFileName =
            this.displayedFileName.slice(0, 33) +
            " ... " +
            this.displayedFileName.substr(-7, 7);
        }
        this.exceedSizeLimit = false;
        this.isFileLoaded = true;
      }
    },
    discardAttachment() {
      this.isFileLoaded = false;
      this.exceedSizeLimit = false;
      this.file = null;
    },

    sentGAFormEvent() {
      let index = this.appParams.locations.findIndex(
        (location) => location.id == this.region
      );

      let regionName = "";
      if (index > -1) {
        regionName = this.appParams.locations[index].name;
      }

      this.$emit("sentGAFormEvent", {
        region: regionName,
        origin_page: window.location.href,
        is_file_loaded: this.isFileLoaded,
      });
    },
  },
};
</script>
